import WikiArticlesView from "@/systems/modules/wiki/WikiArticlesView.vue";
import {modules} from "@/systems/modules/modules.js";
import settings from "@/systems/modules/settings/settings.js";
import WikiCategoriesView from "@/systems/modules/wiki/WikiCategoriesView.vue";
import WikiCategoryHeaderView from "@/systems/modules/wiki/WikiCategoryHeaderView.vue";
import authorization from "@/authorization";
import {RouterView} from "vue-router";

export default {
    initialize() {

    },
    getRoutes: () => ([
        {
            name: "community.modules.wiki",
            path: "wiki",
            component: RouterView,
            props: true,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.wiki) && (authorization.permission("modules.wiki.categories.edit") || authorization.permission("modules.wiki.articles.edit") || authorization.resourceTypePermission("modules.wiki.category", "articles.edit")),
            },
            redirect: { name: "community.modules.wiki.categories" },
            children: [
                {
                    path: "categories",
                    component: RouterView,
                    props: true,
                    children: [
                        {
                            name: "community.modules.wiki.categories",
                            path: "",
                            component: WikiCategoriesView,
                            props: true
                        },
                        {
                            name: "community.modules.wiki.category",
                            path: ":categoryId",
                            component: WikiCategoryHeaderView,
                            props: true,
                            redirect: { name: "community.modules.wiki.category.articles" },
                            children: [
                                {
                                    name: "community.modules.wiki.category.articles",
                                    path: "articles",
                                    component: WikiArticlesView,
                                    props: true
                                }
                            ]
                        },
                    ]
                },
                ...settings.getRoutes(modules.wiki),
            ]
        }
    ]),
};